import {Flex, Box, Text} from '@chakra-ui/react';
import {WarningIcon} from '@chakra-ui/icons';

export interface InfoAlertProps {
  title: string;
  description: string;
  bgColor: string;
  margin?: string;
}

export const InfoAlert: React.FC<InfoAlertProps> = ({
  title,
  description,
  bgColor,
  margin = '20px',
}) => {
  return (
    <Flex
      flexDir={{base: 'column', lg: 'row'}}
      justify="center"
      align="center"
      m={margin}
    >
      <Flex
        w={{lg: '656px'}}
        bgColor={bgColor}
        color="white"
        py="12px"
        px="8px"
        borderRadius="8px"
      >
        <Flex justifyContent="flex-start">
          <WarningIcon w="20px" h="20px" mx="1px" my="1px" />
        </Flex>
        <Box textAlign="left" ml="12.5px">
          <Text textStyle="h7">{title}</Text>
          <Text textStyle="body6">{description}</Text>
        </Box>
      </Flex>
    </Flex>
  );
};
